module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product26-3994c7e0d8b6e361dba3dc8d1989465c.jpg";